// Load all the action handlers in the app
import "./app";
import "./connection";
import "./enrollment";
import "./fingerprint";
import "./location";
import "./network";
import "./news";
import "./pin";
import "./platform";
import "./polling";
import "./resource";
import "./session";
import "./spinner";
import "./toaster";
import "./video";
import "./vognition";



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/all.js